import React from 'react';
import { canAccessQCModule, isAdmin } from '../../utils/roleConstants';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import DataTable from 'react-data-table-component';
import { Navigate, useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

let perPage=30;
const status = {
    NORMAL: 1,
    CONDITION: 2,
    SCRAP: 3,
    REWORK: 4,
    RETURN: 5
  }

class OutgoingSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            jobNo: '',
            jobQty: 0,
            reportNo:'',
            partNo: '',
            description: '',
            inspectionDate:'',
            defectQty: 0,
            defectRate: 0,
            status: '',
            remark: '',
            offset: 0,
            pendingApprovals: [],
            pendingApprovalsMap: {},
            statusFilter: 'pending', // Default to show only pending approvals: 'all', 'pending', 'approved', 'rejected', or status number (1-5)
            isAdmin: false,
            loading: false
          
        };
        this.columns = [
            {
                name: 'No',
                selector: row => row.no,
                sortable: true,
            },
            {
                name: 'Report No',
                selector: row => row.reportNo,
                sortable: true,
                cell: (row, rowIndex) => (
                    <div>
                        <a 
                            href="#"
                            style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (row && row.id) {
                                    if (this.props.navigate) {
                                        this.props.navigate("/outgoing_summary/" + row.id);
                                    } else if (this.props.router && this.props.router.navigate) {
                                        this.props.router.navigate("/outgoing_summary/" + row.id);
                                    }
                                }
                            }}
                        >
                            {row ? row.reportNo : ''}
                        </a>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
            },
            {
                name: 'Part No',
                selector: row => row.partNo,
                sortable: true,
            },
            {
                name: 'Description',
                selector: row => row.description,
                sortable: true,
            },
            {
                name: 'Date',
                selector: row => row.inspectionDate,
                sortable: true,
            },
            {
                name: 'Lot No',
                selector: row => row.lotNo,
                sortable: true,
            },
            {
                name: 'Lot Qty',
                selector: row => row.lotQty,
                sortable: true,
            },
            {
                name: 'Supplier',
                selector: row => row.supplier,
                sortable: true,
            },
            {
                name: 'MFG DC',
                selector: row => row.mfgDc,
                sortable: true,
            },
            {
                name: 'Defect Qty',
                selector: row => row.defectQty,
                sortable: true,
            },
            {
                name: 'Defect Rate',
                selector: row => row.defectRate,
                sortable: true,
            },
            {
                name: 'Status',
                selector: row => row.status,
                sortable: true,
                width: '145px',
                cell: (row, rowIndex) => {
                    let new_status = '';
                    if (row.status === status.NORMAL)
                        new_status = "Accept, Normal";
                    else if (row.status === status.CONDITION)
                        new_status = "Accept, Condition";
                    else if (row.status === status.SCRAP)
                        new_status = "Reject, Scrap";
                    else if (row.status === status.REWORK)
                        new_status = "Reject, Rework";
                    else if (row.status === status.RETURN)
                        new_status = "Reject, Return";

                    return <div>{new_status}</div>;
                }
            },
            {
                name: 'Approve Status',
                width: '180px',
                cell: (row, rowIndex) => {
                    // Find the record in body by matching id
                    const record = this.state.body.find(r => r.id === row.id);
                    const recordId = record ? record.id : (row.id ? row.id : null);
                    const isPendingForMe = this.state.pendingApprovals.includes(recordId);
                    const isApproved = record && (record.approve_status === 1 || record.approve_status === '1');
                    const isRejected = record && (record.approve_status === 2 || record.approve_status === '2');
                    
                    if (isApproved) {
                        return <div style={{ color: 'green', fontWeight: 'bold' }}>APPROVED</div>;
                    }
                    if (isRejected) {
                        return <div style={{ color: 'red', fontWeight: 'bold' }}>REJECTED</div>;
                    }
                    if (isPendingForMe) {
                        return <div style={{ color: 'orange', fontWeight: 'bold' }}>PENDING YOUR APPROVAL</div>;
                    }
                    return <div style={{ color: 'gray' }}>Pending Other Approver</div>;
                },
                ignoreRowClick: true,
            },
            {
                name: 'Remark',
                selector: row => row.remark,
                sortable: true,
            },
            {
                name: 'Action',
                cell: (row, rowIndex) => {
                    // Find the record in body by matching id
                    const record = this.state.body.find(r => r.id === row.id);
                    if (!record && !row.id) {
                        return null;
                    }
                    
                    const recordId = record ? (typeof record.id === 'number' ? record.id : parseInt(record.id, 10)) : (typeof row.id === 'number' ? row.id : parseInt(row.id, 10));
                    if (isNaN(recordId)) {
                        return <div style={{ color: 'gray' }}>Invalid Record</div>;
                    }
                    
                    // Get current user ID first
                    const user = localStorage.getItem('user');
                    if (!user) {
                        return <div style={{ color: 'gray' }}>Not Logged In</div>;
                    }
                    
                    let userId = null;
                    try {
                        const userObj = JSON.parse(user);
                        userId = userObj ? (typeof userObj.id === 'number' ? userObj.id : parseInt(userObj.id, 10)) : null;
                    } catch (e) {
                        return <div style={{ color: 'gray' }}>Invalid User Data</div>;
                    }
                    
                    if (!userId || isNaN(userId)) {
                        return <div style={{ color: 'gray' }}>Invalid User</div>;
                    }
                    
                    // Check approval status first
                    const approveStatus = record.approve_status;
                    const isApproved = approveStatus === 1 || approveStatus === '1';
                    const isRejected = approveStatus === 2 || approveStatus === '2';
                    
                    // If already approved or rejected, show status only (no buttons)
                    if (isApproved) {
                        return <div style={{ color: 'green', fontWeight: 'bold' }}>APPROVED</div>;
                    }
                    if (isRejected) {
                        return <div style={{ color: 'red', fontWeight: 'bold' }}>REJECTED</div>;
                    }
                    
                    // Convert pendingApprovals to numbers for comparison
                    const pendingIdsAsNumbers = (this.state.pendingApprovals || []).map(id => 
                        typeof id === 'number' ? id : parseInt(id, 10)
                    ).filter(id => !isNaN(id));
                    
                    // Check if record is in pending list
                    const isInPendingList = pendingIdsAsNumbers.includes(recordId);
                    
                    // Double-check using pendingApprovalsMap to verify pending_approver_id matches
                    const pendingApprovalsMap = this.state.pendingApprovalsMap || {};
                    const approvalInfo = pendingApprovalsMap[recordId];
                    
                    let isPendingForMe = false;
                    if (approvalInfo) {
                        // Verify the pending_approver_id matches current user
                        const pendingApproverId = approvalInfo.pending_approver_id;
                        const pendingApproverIdNum = typeof pendingApproverId === 'number' 
                            ? pendingApproverId 
                            : parseInt(pendingApproverId, 10);
                        isPendingForMe = !isNaN(pendingApproverIdNum) && pendingApproverIdNum === userId;
                    } else {
                        // If not in map, fall back to list check
                        isPendingForMe = isInPendingList;
                    }
                    
                    // If not pending for current user, show message (no buttons)
                    if (!isPendingForMe) {
                        return <div style={{ color: 'gray' }}>Pending Other Approver</div>;
                    }
                    
                    return (
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <button
                                    style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer', flexShrink: 0 }}
                                    type="button"
                                    onClick={() => {
                                        if (window.confirm("Confirm to approve?")) {
                                            const userId = JSON.parse(localStorage.getItem('user')).id;
                                        fetch(`${config.apiUrl}/approveRecord`, {
                                            method: "post",
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({
                                                record_type: 'outgoing',
                                                record_id: recordId,
                                                approver_id: userId,
                                                action: 'approve'
                                            })
                                        })
                                            .then((response) => {
                                                return response.json();
                                            })
                                            .then((data) => {
                                                if (data.success) {
                                                    window.alert('Approved successfully. ' + (data.message || ''));
                                                    // Add a small delay to ensure database update has completed
                                                    setTimeout(() => {
                                                        this.fetchPendingApprovals().then(() => {
                                                            // Force refresh by resetting offset and adding timestamp
                                                            this.setState({ offset: 0 }, () => {
                                                                this.buildHtmlTable();
                                                                // Refresh badge counts in navigation
                                                                window.dispatchEvent(new CustomEvent('refreshPendingApprovalCounts'));
                                                            });
                                                        }).catch(() => {
                                                            this.setState({ offset: 0 }, () => {
                                                                this.buildHtmlTable();
                                                            });
                                                        });
                                                    }, 500); // 500ms delay
                                                } else {
                                                    window.alert('Approval failed: ' + (data.error || 'Unknown error'));
                                                }
                                            })
                                            .catch((error) => {
                                                console.error('Error:', error);
                                                window.alert('Approval failed');
                                            });
                                    }
                                }}>
                                Approve
                            </button>
                            <button
                                style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer', flexShrink: 0 }}
                                type="button"
                                onClick={() => {
                                    const reason = window.prompt("Please provide rejection reason:");
                                    if (reason !== null && reason.trim() !== '') {
                                        const userId = JSON.parse(localStorage.getItem('user')).id;
                                        fetch(`${config.apiUrl}/approveRecord`, {
                                            method: "post",
                                            headers: {
                                                'Accept': 'application/json',
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({
                                                record_type: 'outgoing',
                                                record_id: recordId,
                                                approver_id: userId,
                                                action: 'reject',
                                                rejection_reason: reason
                                            })
                                        })
                                            .then((response) => {
                                                return response.json();
                                            })
                                            .then((data) => {
                                                if (data.success) {
                                                    window.alert('Record rejected.');
                                                    // Add a small delay to ensure database update has completed
                                                    setTimeout(() => {
                                                        this.fetchPendingApprovals().then(() => {
                                                            // Force refresh by resetting offset and adding timestamp
                                                            this.setState({ offset: 0 }, () => {
                                                                this.buildHtmlTable();
                                                                // Refresh badge counts in navigation
                                                                window.dispatchEvent(new CustomEvent('refreshPendingApprovalCounts'));
                                                            });
                                                        }).catch(() => {
                                                            this.setState({ offset: 0 }, () => {
                                                                this.buildHtmlTable();
                                                            });
                                                        });
                                                    }, 500); // 500ms delay
                                                } else {
                                                    window.alert('Rejection failed: ' + (data.error || 'Unknown error'));
                                                }
                                            })
                                            .catch((error) => {
                                                console.error('Error:', error);
                                                window.alert('Rejection failed');
                                            });
                                    }
                                }}>
                                Reject
                            </button>
                        </div>
                    );
                },
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,

            }];
                
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentWillMount() {

        this.setState({
            processes: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        // Check if user is admin
        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            const userIsAdmin = isAdmin(user);
            this.setState({ isAdmin: userIsAdmin });
            // For admins, default to showing all records
            if (userIsAdmin) {
                this.setState({ statusFilter: 'all' });
            }
        }
        // Fetch pending approvals first, then build table
        this.fetchPendingApprovals().then(() => {
            this.buildHtmlTable();
        }).catch(() => {
            // Even if fetching fails, still build the table
            this.buildHtmlTable();
        });
        
        // Refresh pending approval count in App.jsx when component mounts
        // Dispatch custom event to refresh badge counts in navigation menu
        window.dispatchEvent(new CustomEvent('refreshPendingApprovalCounts'));
    }

    fetchPendingApprovals = () => {
        return new Promise((resolve, reject) => {
            if (localStorage.getItem('user') != null) {
                const user = JSON.parse(localStorage.getItem('user'));
                const userId = user.id;
                const accountId = user.accountId;
                const userIsAdmin = isAdmin(user);
                
                // If admin, fetch all pending approvals for the account
                // Otherwise, fetch only approvals for the current user
                const url = userIsAdmin 
                    ? `${config.apiUrl}/getAllPendingApprovals?account_id=${accountId}&record_type=outgoing`
                    : `${config.apiUrl}/getPendingApprovals?approver_id=${userId}&record_type=outgoing`;
                
                fetch(url, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then((response) => {
                        return response.text().then(text => {
                            if (!text || text.trim() === '') return [];
                            try {
                                const data = JSON.parse(text);
                                return Array.isArray(data) ? data : [];
                            } catch (e) {
                                return [];
                            }
                        });
                    })
                    .then(approvals => {
                        // Ensure approvals is an array
                        const approvalsArray = Array.isArray(approvals) ? approvals : [];
                        
                        // Get current user ID for filtering (even for admins, we only want records pending for them)
                        const user = JSON.parse(localStorage.getItem('user'));
                        const currentUserId = user ? (typeof user.id === 'number' ? user.id : parseInt(user.id, 10)) : null;
                        
                        // Filter to only include records where pending_approver_id matches current user
                        // This is important for admins who might see all pending approvals but should only approve their own
                        const filteredApprovals = approvalsArray.filter(a => {
                            const pendingApproverId = a.pending_approver_id;
                            if (pendingApproverId == null) return false;
                            
                            const approverIdNum = typeof pendingApproverId === 'number' 
                                ? pendingApproverId 
                                : parseInt(pendingApproverId, 10);
                            
                            return !isNaN(approverIdNum) && approverIdNum === currentUserId;
                        });
                        
                        // Convert record_id to number for consistent comparison
                        const pendingRecordIds = filteredApprovals
                            .map(a => {
                                const recordId = a.record_id || a.id;
                                return recordId != null ? parseInt(recordId, 10) : null;
                            })
                            .filter(id => id != null && !isNaN(id));
                        
                        // Also store a map of record_id -> pending_approver_id for double verification
                        const pendingApprovalsMap = {};
                        filteredApprovals.forEach(a => {
                            const recordId = a.record_id || a.id;
                            if (recordId != null) {
                                const recordIdNum = typeof recordId === 'number' ? recordId : parseInt(recordId, 10);
                                if (!isNaN(recordIdNum)) {
                                    pendingApprovalsMap[recordIdNum] = {
                                        record_id: recordIdNum,
                                        pending_approver_id: a.pending_approver_id,
                                        record_type: a.record_type
                                    };
                                }
                            }
                        });
                        
                        console.log('Fetched pending approvals:', approvalsArray.length, 'total records');
                        console.log('Filtered to current user:', filteredApprovals.length, 'records');
                        console.log('Pending record IDs (as numbers):', pendingRecordIds);
                        console.log('Pending approvals map:', pendingApprovalsMap);
                        
                        this.setState({ 
                            pendingApprovals: pendingRecordIds,
                            pendingApprovalsMap: pendingApprovalsMap
                        }, () => {
                            // Resolve after state is updated
                            resolve();
                        });
                    })
                    .catch(error => {
                        console.error('Error fetching pending approvals:', error);
                        this.setState({ pendingApprovals: [] }, () => {
                            reject(error);
                        });
                    });
            } else {
                resolve();
            }
        });
    }

    exportExcel() {
        utils.tableToExcel('datatable', 'masterdata', 'Outgoing_Inpection_Master_' + moment().format('YYYYMMDD') + '.xls');
    };


    buildHtmlTable() {
        this.setState({ loading: true });
        const { tableStyle, tableHeader } = this.state;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            const accountId = user.accountId;
            const pendingRecordIds = this.state.pendingApprovals || [];
            const statusFilter = this.state.statusFilter;
            
            // If filtering by pending and we have pending IDs, fetch those specific records by ID
            // Add timestamp to prevent caching
            const timestamp = new Date().getTime();
            let apiUrl = `${config.apiUrl}/getOutgoingSummaryByCompany?company=${accountId}&keyword=${this.state.keyword}&_t=${timestamp}`;
            
            if (statusFilter === 'pending' && pendingRecordIds.length > 0) {
                // When filtering by pending, fetch records by their specific IDs
                const idsParam = pendingRecordIds.join(',');
                apiUrl += `&ids=${idsParam}&limit=10000&offset=0`; // Use ids parameter to fetch specific records
                console.log('Fetching pending records by IDs:', pendingRecordIds);
            } else {
                apiUrl += `&limit=${perPage}&offset=${this.state.offset}`;
            }
            
            return fetch(apiUrl, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(body => {
                    // login successful if there's a user in the response
                    let array = [];
                    const products = [];
                    const pendingRecordIds = this.state.pendingApprovals;

                    // Ensure body.data is an array
                    const bodyData = Array.isArray(body.data) ? body.data : [];

                    // Filter data based on statusFilter
                    let filteredData = bodyData;
                    const statusFilter = this.state.statusFilter;
                    
                    if (statusFilter === 'all') {
                        // Show all records
                        filteredData = bodyData;
                    } else if (statusFilter === 'pending') {
                        // Show only pending approvals
                        if (pendingRecordIds.length > 0) {
                            // Convert both to numbers for comparison, in case one is string and other is number
                            filteredData = bodyData.filter(data => {
                                const recordId = typeof data.id === 'number' ? data.id : parseInt(data.id);
                                return pendingRecordIds.some(pendingId => {
                                    const pendingIdNum = typeof pendingId === 'number' ? pendingId : parseInt(pendingId);
                                    return recordId === pendingIdNum;
                                });
                            });
                            console.log('Filtered pending approvals:', filteredData.length, 'out of', bodyData.length, 'total records');
                        } else {
                            filteredData = [];
                            console.log('No pending approvals found - pendingRecordIds is empty');
                        }
                    } else if (statusFilter === 'approved') {
                        // Show only approved records
                        filteredData = bodyData.filter(data => 
                            data.approve_status === 1 || data.approve_status === '1'
                        );
                    } else if (statusFilter === 'rejected') {
                        // Show only rejected records
                        filteredData = bodyData.filter(data => 
                            data.approve_status === 2 || data.approve_status === '2'
                        );
                    } else if (['1', '2', '3', '4', '5'].includes(statusFilter)) {
                        // Filter by approve_condition status (1-5)
                        const statusNum = parseInt(statusFilter);
                        filteredData = bodyData.filter(data => 
                            data.approve_condition === statusNum
                        );
                    }

                    // Sort data: pending approvals first, then by ID descending (newest first)
                    if (Array.isArray(filteredData)) {
                        filteredData.sort((a, b) => {
                            const aId = typeof a.id === 'number' ? a.id : parseInt(a.id);
                            const bId = typeof b.id === 'number' ? b.id : parseInt(b.id);
                            const aIsPending = pendingRecordIds.includes(aId);
                            const bIsPending = pendingRecordIds.includes(bId);
                            
                            // If one is pending and the other is not, pending comes first
                            if (aIsPending && !bIsPending) return -1;
                            if (!aIsPending && bIsPending) return 1;
                            
                            // If both are pending or both are not, sort by ID descending (newest first)
                            return bId - aId;
                        });
                    }

                    // Ensure filteredData is an array before mapping
                    if (Array.isArray(filteredData)) {
                        filteredData.forEach((data, index) => {
                            // Ensure data.id and data.Timestamp are valid
                            if (!data.id || !data.Timestamp) {
                                console.warn('Invalid data record:', data);
                                return; // Skip invalid records
                            }
                            const timestamp = moment(data.Timestamp);
                            if (!timestamp.isValid()) {
                                console.warn('Invalid timestamp for record:', data.id, data.Timestamp);
                                return; // Skip records with invalid timestamps
                            }
                            const reportNo = timestamp.format('YYYYMMDD') + '3' + data.id;
                            array.push({
                                id: data.id,
                                reportNo: reportNo,
                                no: index + this.state.offset + 1,
                                partNo: data.master ? data.master.partNo : '',
                                description: data.master ? data.master.partDesc : '',
                                inspectionDate: timestamp.format('YYYY-MM-DD'),
                                jobNo: data.jobNo,
                                jobQty: data.jobQty,
                                customer: data.customer,
                                model: data.model,
                                defectQty: data.defectQty,
                                defectRate: (data.defectQty / data.jobQty * 100).toFixed(2),
                                status: data.approve_condition,
                                remark: data.remark
                            })
                        });
                    }

                    this.setState({ 
                        products: array,
                        body: Array.isArray(filteredData) ? filteredData : [],
                        pageCount: body.meta && body.meta.total_count && body.meta.limit 
                            ? Math.ceil(body.meta.total_count / body.meta.limit) 
                            : 1,
                        loading: false
                    });
                })
                .catch(error => {
                    console.error('Error loading summary data:', error);
                    this.setState({ products: [], body: [], loading: false });
                });
        }

        this.setState({ loading: false });
        return Promise.resolve();
    }



    cellLink(cell, row, enumObject, rowIndex) {
        const url = "/outgoing_summary/" + this.state.body[rowIndex].id;
        return (
            <div>
                <a onClick={() => {
                    if (this.props.navigate) {
                        this.props.navigate(url);
                    } else if (this.props.router && this.props.router.navigate) {
                        this.props.router.navigate(url);
                    }
                }}>{this.state.body[rowIndex]?this.state.body[rowIndex].reportNo:''}</a>
            </div>
        )
    }

    cellStatus(cell, row, enumObject, rowIndex) {
        let new_status = '';
        if (row.status == status.NORMAL)
            new_status = "Accept, Normal";
        else if (row.status == status.CONDITION)
            new_status = "Accept, Condition";
        else if (row.status == status.SCRAP)
            new_status = "Reject, Scrap";
        else if (row.status == status.REWORK)
            new_status = "Reject, Rework";
        else if (row.status == status.RETURN)
            new_status = "Reject, Return";

        return (
           <div>
              {new_status}
            </div>
        )
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            this.state.body[rowIndex].approve_status?
            <div style={{color:'green',fontWeight:'bold'}}>APPROVED</div>:<div>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Confirm to approve?") && fetch(`${config.apiUrl}/approveOutgoingSummary?id=${this.state.body[rowIndex].id}`, {
                            method: "post",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                      }
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            window.alert('Approve Successfully.');
                            this.setState({ modalShow: false });
                            this.buildHtmlTable();
                        }
                        if (response.status == 201) {
                            window.alert('Approve failed');
                        }
                    })
                }>
                    Approve
            </button>
            </div>
        )
    }

    handlePageClick(data) {
        let selected = data.selected;
        let offset = Math.ceil(selected * perPage);

        this.setState({ offset: offset }, () => {
          this.buildHtmlTable();
        });
      };


     handleChange (event, newValue) {
        this.setState({ tabvalue: newValue });
    }

      
    render() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            return <Navigate to='/' />
        }
        let user;
        try {
            user = JSON.parse(userData);
        } catch (e) {
            console.error('Error parsing user data:', e);
            return <Navigate to='/' />
        }
        // Allow access for: QC Admin or superadmin
        if (!canAccessQCModule(user)) {
            console.log('Access denied. User:', user?.username, 'Role:', user?.role, 'is_superadmin:', user?.is_superadmin);
            return <Navigate to='/' />
        }
        let { keyword,products, } = this.state;


        return (
            <div class="container">
                <div style={{ marginBottom: '20px', padding: '15px 0' }}>
                    <Row>
                        <Col sm={6} md={4}>
                            <FormControl 
                                type="text" 
                                placeholder="partNo, description, customer" 
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }} 
                                onKeyPress={ev => {
                                    if (ev.key === 'Enter') {
                                        ev.preventDefault();
                                        this.setState({ offset: 0 }, () => {
                                            this.buildHtmlTable();
                                        });
                                    }
                                }}
                                value={keyword} 
                            />
                        </Col>
                        <Col sm={3} md={2}>
                            <Button
                                variant="primary"
                                onClick={e => {
                                    this.setState({ offset: 0 }, () => {
                                        this.buildHtmlTable();
                                    });
                                }}
                                style={{ width: '100%' }}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col sm={3} md={3}>
                            <FormControl
                                as="select"
                                value={this.state.statusFilter}
                                onChange={ev => {
                                    this.setState({ 
                                        statusFilter: ev.target.value,
                                        offset: 0 
                                    }, () => {
                                        this.buildHtmlTable();
                                    });
                                }}
                                style={{ width: '100%' }}
                            >
                                <option value="all">All Records</option>
                                <option value="pending">Pending Approval</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                                <option value="1">Accept, Normal</option>
                                <option value="2">Accept, Condition</option>
                                <option value="3">Reject, Scrap</option>
                                <option value="4">Reject, Rework</option>
                                <option value="5">Reject, Return</option>
                            </FormControl>
                        </Col>
                    </Row>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="outgoingTable" class="container" style={{ overflowY: 'auto' }} >
                <DataTable
                        columns={this.columns}
                    data={products}
                    progressPending={this.state.loading}
                    progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading outgoing summary" />}
                    pagination
                        highlightOnHover
                    />
                </div>
            </div>

        );
    }
}

// HOC to inject useNavigate hook into class component
function withRouter(Component) {
    return (props) => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
}

const OutgoingSummaryWithRouter = withRouter(OutgoingSummary);
export { OutgoingSummaryWithRouter as OutgoingSummary };
